var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "task task_new", attrs: { id: "form-task-new" } },
    [
      _c("div", { staticClass: "task__row task-summary" }, [
        _c("div", { staticClass: "task__col" }, [
          _c("div", { staticClass: "task-summary__title" }, [
            _c("input", {
              staticClass: "form-input",
              attrs: {
                type: "text",
                "aria-invalid": _vm.corruptedFields.includes("name"),
                placeholder: "Название задачи",
              },
              domProps: { value: _vm.editable.task.name },
              on: {
                input: (e) => _vm.setEditable("name", e.target.value, "task"),
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-prop" }, [
            _c("strong", [_vm._v("Постановщик задачи:")]),
            _vm._v(" "),
            _c("div", { staticClass: "task-prop__value" }, [
              _vm._v(
                _vm._s(_vm.user.lastname) + " " + _vm._s(_vm.user.firstname)
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "task__col" },
          [
            _c("h3", { staticClass: "task-summary__title" }),
            _vm._v(" "),
            _c("Priority", {
              attrs: { value: _vm.editable.task.priority },
              on: { update: (v) => _vm.setEditable("priority", v, "task") },
            }),
            _vm._v(" "),
            _c("Tags", {
              attrs: { tags: _vm.editable.task.tags },
              on: { update: (v) => _vm.setEditable("tags", v, "task") },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "task__col" }),
        _vm._v(" "),
        _c("div", { staticClass: "task__col" }),
      ]),
      _vm._v(" "),
      _c("SubtaskType", {
        staticClass: "task-task-type",
        attrs: { tasks: _vm.tasks, active: _vm.editable.task.planTaskId },
        on: { typeChange: (v) => _vm.setEditable("planTaskId", v, "task") },
      }),
      _vm._v(" "),
      _vm.editable.task.planTaskId
        ? [
            _c(
              "StageNewListTable",
              _vm._l(_vm.editable.task.stages, function (stage) {
                return _c("TaskNewStage", {
                  key: stage.tmpId,
                  attrs: { stages: _vm.editable.task.stages, stage: stage },
                  on: { update: _vm.updateStage, delete: _vm.deleteStage },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "stage-new-list-foot" }, [
              _c(
                "a",
                {
                  staticClass: "plan__subtask-type-add icon-text",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.createNewStage.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("Icon", { attrs: { id: "plus", size: "26" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Добавить этап")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "task-stream-count" }, [
                _c("div", { staticClass: "task-stream-count__label" }, [
                  _vm._v("Кол-во подзадач:"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "task-stream-count__value" }, [
                  _c("input", {
                    staticClass: "form-input",
                    staticStyle: { width: "55px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.editable.task.streamCount },
                    on: {
                      input: function ($event) {
                        return _vm.setEditable(
                          "streamCount",
                          $event.target.value,
                          "task"
                        )
                      },
                      blur: function ($event) {
                        return _vm.setEditable(
                          "streamCount",
                          $event.target.value || 1,
                          "task"
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.createTask.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Создать задачу")]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.saveErrors
        ? _c("p", { staticClass: "error-txt" }, [
            _vm._v(_vm._s(_vm.saveErrors)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }